export const KG_PER_TONNE = 1000

export type NetMassDisplayUnit = 'tonnes' | 'kilograms'

export function tonnesToDisplayAmount(tonnes: number, unit: NetMassDisplayUnit): number {
  if (unit === 'kilograms') {
    return tonnes * KG_PER_TONNE
  }
  return tonnes
}

export function formatNetMassFromTonnes(
  tonnes: number,
  unit: NetMassDisplayUnit,
  numberFormatter3Decimals: (value: number) => string
): string {
  const amount = tonnesToDisplayAmount(tonnes, unit)
  const suffix = unit === 'tonnes' ? ' t' : ' kg'
  return `${numberFormatter3Decimals(amount)}${suffix}`
}

/** Formatted mass for liability overview narrative and formulas (3 dp + unit suffix). */
export function formatVolumeForLiability(
  volumeTonnes: number,
  unit: NetMassDisplayUnit,
  numberFormatter3Decimals: (value: number) => string
): string {
  return formatNetMassFromTonnes(volumeTonnes, unit, numberFormatter3Decimals)
}

export function getLiabilityVolumeDisplayParts(
  volumeTonnes: number,
  unit: NetMassDisplayUnit,
  numberFormatter3Decimals: (value: number) => string
): { volumeAmount: string } {
  return {
    volumeAmount: numberFormatter3Decimals(tonnesToDisplayAmount(volumeTonnes, unit))
  }
}
